import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import EarningsTab from "./EarningsTab";

const EarningPartner = (props) => {
  //meta title
  document.title = `${props.t("Transactions")} | ${process.env.REACT_APP_CMS_TITLE}`;

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title={props.t("Transactions")} breadcrumbItem={props.t("Transactions")} />
        {/* Add your transactions content here */}
        <div className="d-flex flex-column gap-4">
          <EarningsTab />
        </div>
      </Container>
    </div>
  );
};

export default withTranslation()(EarningPartner);
